import '../styles/styles.scss';
import 'swiper/css/bundle';

window.onload = async () => { 
    if (document.getElementsByClassName('menu').length) {
        await import('./menu').then((module) => module.default());
    }

    // Hero-slider
    if (document.getElementsByClassName('hero-slider').length) {
        await import('./hero-slider').then((module) => module.default());
    }

    // Review-slider
    if (document.getElementsByClassName('review-slider').length) {
        await import('./review-slider').then((module) => module.default());
    }

    // Accordions
    if (document.getElementsByClassName('accordion').length) {
        await import('./accordion').then((module) => module.default());
    }

    // Hero images
    if (document.getElementsByClassName('hero-images-left').length || document.getElementsByClassName('hero-images-right').length) {
        await import('./hero-images').then((module) => module.default());
    }

    // Images slider
    if (document.getElementsByClassName('images-slider').length) {
        await import('./images-slider').then((module) => module.default());
    }

    // Paralax move
    if (document.getElementsByClassName('paralax-move').length) {
        await import('./paralax').then((module) => module.default());
    }
};

document.addEventListener('DOMContentLoaded', async () => {
    // Imports
});